/**
 export default {
    realization: {
        icon: 'file-image',
        text: 'Realisasi Kinerja',
        route: 'general.performance.realization',
    },
    individu: {
        icon: 'idcard',
        text: 'Penilaian Individu',
        route: 'general.performance.score',
    },
    evaluation: {
        icon: 'file-done',
        text: 'Nilai',
        route: 'general.performance.evaluation',
    },
    recap: {
        icon: 'book',
        text: 'Rekap Penilaian',
        route: 'general.performance.recap',
    },
    score: {
        icon: 'file-protect',
        text: 'Penilaian',
        route: 'general.performance.score',
        children: {
            staff: {
                icon: null,
                text: 'Daftar Staff',
                route: 'general.performance.staff',
            },
            performance: {
                icon: null,
                text: 'Nilai Kinerja',
                route: 'general.performance.performance',
            },
            approval: {
                icon: null,
                text: 'Approval Realisasi',
                route: 'general.performance.approval',
            },
        }
    },
    guidance: {
        icon: 'file-sync',
        text: 'Bimbingan',
        route: 'general.performance.guidance',
        children: {
            evaluation: {
                icon: null,
                text: 'Evaluasi',
                route: 'general.performance.evaluasi',
            },
            coaching: {
                icon: null,
                text: 'Coaching',
                route: 'general.performance.coaching',
            },
            mentoring: {
                icon: null,
                text: 'Mentoring',
                route: 'general.performance.mentoring',
            },
            counseling: {
                icon: null,
                text: 'Counseling',
                route: 'general.performance.counseling',
            },
        }
    },
}
 **/

import mentor from './mentor'
import attendant from './attendant'
import scoring from './scoring'

const performance = Object.assign({}, mentor, scoring, attendant)

export default performance
